<template>
  <div class="search-results">
    <div class="scroll-box">
      <section v-if="groupedResults.tag.length">
        <h1>
          {{ $t('tag.plural') }}
        </h1>
        <div class="results tags">
          <div v-for="result in groupedResults.tag" :key="result.id" class="search-result">
            <tag-badge :tag="result" />
          </div>
        </div>
      </section>
      <section v-if="groupedResults.person.length">
        <h1>
          {{ $t('person.plural') }}
        </h1>
        <div class="results people">
          <div v-for="result in groupedResults.person" :key="result.id" class="search-result">
            <person-card :person="result" />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import SetTextColor from '../../lib/set-text-color'
import TagBadge from '../components/UI/TagBadge'
import PersonCard from '../components/person/PersonCard'

export default {
  name: 'SearchResults',
  components: { TagBadge, PersonCard },
  props: {
    /** @type {Array} */
    results: { type: Array, default: () => [] },
    /** @type {String} */
    searchString: { type: String, default: '' }
  },

  data: () => ({}),

  computed: {
    /**
     * @type {{people: Array, tags: Array}}
     */
    groupedResults () {
      const groups = { tag: [], person: [] }
      if (this.results) {
        // !!! DEBUG !!!
        console.log(`%c %c groupedResults: this.results: `, 'background:#ffbb00', 'color:#00aaff', this.results)
        this.results.forEach(res => {
          if (res.type) {
            groups[res.type].push(res)
          }
        })
      }
      return groups
    }
  },

  mounted () {
    SetTextColor()
  },

  methods: {
    resultRouteTo (result) {
      return { name: result.type, params: { id: result.id } }
    }
  }
}
</script>

<style lang="scss">
  @import "../../assets/styles/vars";

  .search-results {
    height: 100%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;

    margin-top: -$basic-padding;

    padding: 0 $basic-padding;

    .scroll-box {
    }
    section {
      margin-bottom: $basic-size;
      .results {
        display: flex;

        &.tags {
        }

        &.people {
          flex-flow: column;
          align-items: flex-start;

          .person-card {
            //background: $dynamic-paper-color;
            padding-right: $basic-padding;
            margin: 0 $basic-padding $basic-padding 0;
          }
        }
      }
      //margin-right: $basic-padding;
      h1 {
        //margin-bottom: $basic-padding * 2;
      }
    }
  }
</style>
